import { QueryClient } from '@tanstack/react-query'
import { isApiError } from '@/lib/http/errors'

/** Static reference data changes on the order of months, not minutes. */
export const STATIC_QUERY_OPTIONS = {
  staleTime: Number.POSITIVE_INFINITY,
  gcTime: Number.POSITIVE_INFINITY,
} as const

export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // Only transport failures and 5xx are worth repeating; a 400 or a 409 will
        // simply be rejected again.
        retry: (failureCount, error) => failureCount < 2 && isApiError(error) && error.retryable,
        retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 8000),
        staleTime: 30_000,
        // A citizen alt-tabbing away mid-application must not trigger background
        // traffic against a government API when they come back.
        refetchOnWindowFocus: false,
        throwOnError: false,
      },
      mutations: {
        // Nothing in this flow is idempotent and the spec offers no idempotency
        // key: a retried `initiate` or `finalise` creates a second application.
        // See docs/api-gaps.md #8.
        retry: false,
      },
    },
  })
}
